import React from 'react';
import { Container } from 'react-bootstrap';
import Particle from '../Particle';
import Github from './Github';
import FrontEnd from './FrontEnd';
import BackEnd from './BackEnd';
import Database from './Database';
import Programming from './Programming';
import Tools from './Tools';

const Skills = () => {
  return (
    <Container fluid className="skill-section">
      <Particle />
      <Container>
        <h1 className="sub-heading">Front-End</h1>
        <FrontEnd />

        <h1 className="sub-heading">Back-End</h1>
        <BackEnd />

        <h1 className="sub-heading">Database</h1>
        <Database />

        <h1 className="sub-heading">Programming</h1>
        <Programming />

        <h1 className="sub-heading">Tools and Other Technologies</h1>
        <Tools />
        {/* <Github /> */}
      </Container>
    </Container>
  );
};

export default Skills;
